import { render, staticRenderFns } from "./DocxTemplateRemoveDialog.vue?vue&type=template&id=148ab151&scoped=true"
import script from "./DocxTemplateRemoveDialog.vue?vue&type=script&lang=js"
export * from "./DocxTemplateRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./DocxTemplateRemoveDialog.vue?vue&type=style&index=0&id=148ab151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ab151",
  null
  
)

export default component.exports